export default __webpack_public_path__ + "static/media/team-call.dde87957.wav";